(function ($) {
    const TABLET_BREAKPOINT = 1200;
    let activeInstances = [];

    function isBelowTablet() {
        return window.matchMedia(`(max-width: ${TABLET_BREAKPOINT}px)`).matches;
    }

    function enableSlider(row) {
        if (row.dataset.sliderActive === 'true') return;

        const nextEl = row.querySelector('.swiper-button-next');
        const prevEl = row.querySelector('.swiper-button-prev');
        const items = Array.from(row.children).filter(
            (item) => item !== nextEl && item !== prevEl
        );
        const wrapper = document.createElement('div');
        wrapper.classList.add('swiper-wrapper');

        items.forEach((item) => {
            item.classList.add('swiper-slide');
            wrapper.appendChild(item);
        });

        row.appendChild(wrapper);
        row.classList.add('swiper-container');

        const config = {
            slidesPerView: 'auto',
            spaceBetween: 12,
            freeMode: true,
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
            watchOverflow: true,
            watchSlidesVisibility: true,
            mousewheel: {
                forceToAxis: true,
            },
        };
        if (nextEl && prevEl) {
            config.navigation = { nextEl, prevEl };
        }

        const swiper = new Swiper(row, config);

        row._swiperInstance = swiper;
        activeInstances.push(swiper);
        row.dataset.sliderActive = 'true';
    }

    function disableSlider(row) {
        if (row.dataset.sliderActive !== 'true') return;

        if (row._swiperInstance) {
            activeInstances = activeInstances.filter((s) => s !== row._swiperInstance);
            row._swiperInstance.destroy(true, true);
            row._swiperInstance = null;
        }

        const wrapper = row.querySelector('.swiper-wrapper');
        if (wrapper) {
            Array.from(wrapper.children).forEach((item) => {
                item.classList.remove('swiper-slide');
                row.appendChild(item);
            });
            wrapper.remove();
        }

        row.classList.remove('swiper-container');
        row.dataset.sliderActive = 'false';
    }

    function updateProductCategoriesSliders() {
        document.querySelectorAll('.product-categories-block__row').forEach((row) => {
            if (isBelowTablet()) {
                enableSlider(row);
            } else {
                disableSlider(row);
            }
        });
    }

    updateProductCategoriesSliders();

    $(document).gp_ready(function () {
        updateProductCategoriesSliders();
    });

    window.addEventListener('resize', updateProductCategoriesSliders);
    window.addEventListener('load', () => {
        activeInstances.forEach((s) => s.update());
    });

    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
            activeInstances.forEach((s) => s.update());
        });
    }
})(jQuery);